// extracted by mini-css-extract-plugin
module.exports = {"btn":"scrollBtn_btn__2_jDS","icon":"scrollBtn_icon__RR9mY"};